import style from './list.module.scss'

interface ListProps {
  columns: string[]
  children: React.ReactNode
  className?: string
  [key: string]: any
}

function List({ columns, children, className, ...props }: ListProps) {
  return (
    <ul className={style.list + ' ' + className} {...props}>
      <li className={style.list_header}>
        {columns.map((item, index) => (
          <span key={index}>{item}</span>
        ))}
      </li>
      {children}
    </ul>
  )
}

export default List
